<template>
	<div>
		<Header />
		<router-view id="app" class="wrapper" />
		<Footer />
		<button
      class="
        hidden
        items-center
        justify-center
        bg-primary
        text-white
        w-10
        h-10
        rounded-md
        fixed
        bottom-8
        right-8
        left-auto
        z-[999]
        hover:bg-dark
        back-to-top
        shadow-md
        transition
        duration-300
        ease-in-out
      "
    >
      <span
        class="w-3 h-3 border-t border-l border-white rotate-45 mt-[6px]"
      ></span>
    </button>
	</div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import init from "@/assets/js/init";

export default {
	components: {
		Header,
		Footer,
	},
	mounted: function() {
		init();
	}
}
</script>
